import { HomeBar, Footer, HeroAb, Goals } from "../component";
import { useEffect, useState, useRef } from "react";

const About = () => {
    const [offSetY, setOffSetY] = useState(0);

    const handleScrolling = () => {
        if (!mainDiv.current.scrollTop) return;
        setOffSetY(mainDiv.current.scrollTop);
    }
    const mainDiv = useRef();


    useEffect(() => {
        if (!mainDiv.current) return;
        mainDiv.current.addEventListener('scroll', handleScrolling);

        return () => mainDiv.current.removeEventListener('scroll', handleScrolling);
    }, []);

    const handleScroll = (e) => {
        let target_id = e.target.getAttribute('data-target');
        let target = document.querySelector(`#${target_id}`);
        target.scrollIntoView({behavior: "smooth"});
    }

    return (
        <div className="ladscatch__container" ref={(e) => mainDiv.current=e}>
            <HomeBar onScroll={(e) => handleScroll(e)} scrollY={offSetY} />
            <HeroAb />
            <Goals />
            <Footer />
        </div>
    )
}

export default About;